import {SupportedLocales} from '@gl/lit/types/locale.js';

export const reviewAudiencesLocale = {
  [SupportedLocales.EN]: {
    table: {
      noMatches: {
        headline: 'There are no audiences to review.',
        caption: 'Create or submit an audience to approve',
      },
      setupAudience: {
        headline: 'Setup Audience Governance',
        caption: 'Setup audience review for your team',
        createButton: 'Setup',
      },
      noSetup: {
        headline: 'Audience Governance is not configured',
        caption: 'Audience review has not been configured for your team',
      },
      createButton: 'Go To Audiences',
    },
    review: {
      error: 'Something went wrong attempting to review',
    },
    approve: {
      success: 'Successfully approved',
      error: 'Something went wrong while approving',
    },
  },
  [SupportedLocales.ES]: {
    table: {
      noMatches: {
        headline: 'No hay audiencias para revisar.',
        caption: 'Crea o envía una audiencia para aprobar',
      },
      setupAudience: {
        headline: 'Configurar Gobernanza de Audiencia',
        caption: 'Configura la revisión de audiencia para tu equipo',
        createButton: 'Configurar',
      },
      noSetup: {
        headline: 'La Gobernanza de Audiencia no está configurada',
        caption:
          'La revisión de audiencia no ha sido configurada para tu equipo',
      },
      createButton: 'Ir a Audiencias',
    },
    review: {
      error: 'Algo salió mal al intentar revisar',
    },
    approve: {
      success: 'Aprobado exitosamente',
      error: 'Algo salió mal al aprobar',
    },
  },
};
